var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';
var uuidv4 = require('uuid/v4');
var _ = require('lodash');

var logdown = require('logdown');
var console = logdown('rx-forms-rx-plaintext', { prefixColor: '#0288d1' });

var RXPlainText = function (_Component) {
    _inherits(RXPlainText, _Component);

    function RXPlainText(props) {
        _classCallCheck(this, RXPlainText);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.doOnChange = function (values) {
            _this.props.onChange({ target: { value: values, id: _this.props.name } });
        };

        _this.state = {
            invalid: false,
            value: _this.props.value && _this.props.value != undefined ? _this.props.value : "",
            transformer: _this.props.transformers[_this.props.name] ? _this.props.transformers[_this.props.name] : null
        };

        return _this;
    }

    RXPlainText.prototype.componentDidMount = function componentDidMount() {};

    RXPlainText.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {

        if (this.props.data != prevProps.data) {
            this.setState({ data: this.props.data });
        }
        if (this.props.value != prevProps.value) {
            console.log('try to update with ', this.props.value);
            this.setState({ value: this.props.value });
        }
        if (this.props.transformers[this.props.name] != prevProps.transformers[this.props.name]) {
            this.setState({ transformer: this.props.transformers[this.props.name] });
        }
    };

    RXPlainText.prototype.render = function render() {

        // console.log(`in render with `, this.props);
        var props = _.omit(this.props, 'onFileAdded');

        var value = props.value,
            props = _objectWithoutProperties(props, ['value']);

        var innerValue = value;
        if (this.state.transformer) {
            innerValue = this.state.transformer(value);
        }

        return React.createElement(
            React.Fragment,
            null,
            React.createElement(Input, _extends({ plaintext: true, style: { border: "1px solid #ced4da", backgroundColor: "#e1f5fe" }, invalid: this.state.invalid, valid: this.state.valid, onBlur: this.onBlur, disabled: this.state.disabled, className: 'form-control' }, props, { onChange: function onChange() {}, value: innerValue })),
            React.createElement(
                FormFeedback,
                { valid: this.state.valid },
                this.state.feedbackMessage
            )
        );
    };

    return RXPlainText;
}(Component);

RXPlainText.defaultProps = {};

export default RXPlainText;